import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import bgImage from "../assets/images/background1.png";
import Arrow from "../assets/images/arrow.svg";
import Star from "../assets/images/star.svg";
import Graph1 from "../assets/images/graph1.svg";
import Graph2 from "../assets/images/graph-2.svg";
import Greentick from "../assets/images/grrentick.svg";
import Greater from "../assets/images/greaterthan.svg";
import "../assets/css/swiper.css";
import { useNavigate } from "react-router-dom";
import LoginIcon from "@mui/icons-material/Login";
import PersonAddIcon from "@mui/icons-material/PersonAdd";

const Home = () => {
  const navigate = useNavigate();
  const images = [
    // {
    //   id: 1,
    //   url: CpgramImage,
    //   title: "UP CM Helpline Portal",
    //   description:
    //     "A dedicated platform to address and resolve citizen complaints efficiently. Empowering transparency and accessibility for all.",
    // },
    {
      id: 2,
      url: bgImage,
      title: "NCW — AI-Powered Complaint Redressal System",
      description: "AI-Powered Multilingual Complaint Redressal, National Commission for Women",
      subtitle: "Suraksha, Samman, Sashaktikaran — Safety, Dignity, Empowerment",
      description2:
        "Join hands in ensuring safety, dignity and justice for every woman. Report domestic violence, workplace harassment, police apathy, cyber crime and other complaints with AI-powered assistance and intelligent complaint analysis in 22 Indian languages — and track their resolution on a transparent, technology-driven platform built for citizens, officers and administrators alike.",
    },
  ];

  const card = [
    {
      title: "Complaint status is updated",
      discription: "2m ago",
    },
    {
      title: "Inquiry Committee report received",
      discription: "5m ago",
    },
    {
      title: "Complaint details verified",
      discription: "10m ago",
    },
  ];

  return (
    <div className="flex-grow w-full relative">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        loop
        className="absolute inset-0 w-full h-full"
      >
        {images.map((image) => (
          <SwiperSlide key={image.id}>
            <div className="relative w-full h-full flex items-center justify-center text-white overflow-hidden bg-page-bg">
              {/* Site-wide animated water backdrop */}
              <div className="water-backdrop" aria-hidden="true">
                <svg className="wave-back" viewBox="0 0 2400 220" preserveAspectRatio="none">
                  <path fill="#9c2942" fillOpacity="0.06" d="M0,180 Q100,60 200,180 Q300,60 400,180 Q500,60 600,180 Q700,60 800,180 Q900,60 1000,180 Q1100,60 1200,180 Q1300,60 1400,180 Q1500,60 1600,180 Q1700,60 1800,180 Q1900,60 2000,180 Q2100,60 2200,180 Q2300,60 2400,180 L2400,220 L0,220 Z" />
                </svg>
                <svg className="wave-front" viewBox="0 0 2400 180" preserveAspectRatio="none">
                  <path fill="#4a0e1e" fillOpacity="0.045" d="M0,140 Q150,40 300,140 Q450,40 600,140 Q750,40 900,140 Q1050,40 1200,140 Q1350,40 1500,140 Q1650,40 1800,140 Q1950,40 2100,140 Q2250,40 2400,140 L2400,180 L0,180 Z" />
                </svg>
              </div>
              {/* Black Overlay */}
              {/* <div className="absolute inset-0 bg-black opacity-70"></div> */}

              {/* Content */}
              <div className="flex flex-col md:flex-row items-center w-full px-4 md:px-12">
                <div className="w-full md:w-[70%] ml-4 md:ml-12 relative text-start px-4 md:px-6 max-w-[620px]">
                  <h1 className="inline-block text-[36px] sm:text-[40px] md:text-[56px] font-[900] font-serif leading-[1.08] bg-gradient-to-r from-[#9c2942] to-[#4a0e1e] bg-clip-text text-transparent mb-4">
                    {image.title}
                  </h1>
                  <p className="text-base sm:text-lg md:text-[21px] font-[800] text-[#0e2f4d] mb-[14px]">
                    {image.description}
                  </p>
                  <h1 className="text-lg sm:text-xl md:text-[17px] font-[800] text-[#c1671f] mb-[12px]">
                    {image.subtitle}
                  </h1>
                  <p className="text-sm sm:text-base md:text-[15.5px] text-[#4c6478] leading-[1.7] mb-[30px] max-w-[540px]">
                    {image.description2}
                  </p>
                  <div className="flex flex-wrap gap-[16px]">
                    <button
                      className="bg-[#c9962f] text-white font-[700] text-[14px] px-[22px] py-[11px] rounded-full flex items-center gap-[8px] shadow-[0_4px_14px_rgba(201,150,47,0.4)] transition duration-300 hover:opacity-90"
                      onClick={() => navigate("/login")}
                    >
                      <i className="fa-solid fa-right-to-bracket text-sm"></i>
                      <span>Sign In</span>
                    </button>
                    <button
                      className="bg-[#c9962f] text-white font-[700] text-[14px] px-[22px] py-[11px] rounded-full flex items-center gap-[8px] shadow-[0_4px_14px_rgba(201,150,47,0.4)] transition duration-300 hover:opacity-90"
                      onClick={() => navigate("/register")}
                    >
                      <i className="fa-solid fa-user-plus text-sm"></i>
                      <span>Sign Up</span>
                    </button>
                  </div>
                </div>
                <div className="hidden md:flex w-[90%] flex-col items-center justify-center -translate-y-8 lg:-translate-y-12">
                  <div className="-mr-[50%] z-10 shadow-xl shadow-gray-400 bg-white rounded-lg overflow-hidden">
                    <img src={Graph1} alt="graph" className="w-25 h-20" />
                  </div>
                  <div className="w-[40%] h-auto bg-white text-black p-4 rounded-xl shadow-xl shadow-gray-400 z-20">
                    <h1 className="font-bold text-lg mb-3">Live Updates</h1>
                    {card.map((card) => (
                      <div className="w-[90%] bg-[#ECFDF5] m-2 p-2 rounded-md flex items-center justify-between">
                        <img
                          src={Greentick}
                          alt="tick"
                          className="ml-1 w-4 h-4"
                        />

                        <div className="w-[75%] text-start">
                          <h3>{card.title}</h3>
                          <p className="text-sm text-gray-500">
                            {card.discription}
                          </p>
                        </div>
                        <img
                          src={Greater}
                          alt="tick"
                          className="ml-1 w-4 h-4"
                        />
                      </div>
                    ))}
                  </div>
                  <div className="-ml-[50%] z-30 shadow-xl shadow-gray-400 bg-white rounded-lg overflow-hidden">
                    <img src={Graph2} alt="graph" className="w-25 h-20" />
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Home;
